module.exports = __webpack_public_path__ + "fonts/Evogria Italic.811e4ccd.woff";